// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___eA3mt","wrapper":"wrapper___2amsu","subtitle":"subtitle___3QROI","submit":"submit___3jhmB"};